import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

export function addFabricContract(contractData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(contractData);
  let response = axios.post(
    `${API_END_POINT}/company/contract/fabric/add`,
    body,
    config
  );

  return response;
}

export function addConvertionContract(companyData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(companyData);
  let response = axios.post(
    `${API_END_POINT}/company/contract/conversion/add`,
    body,
    config
  );

  return response;
}

export function getAllContracts(params) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = params;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/contract/get/company/${companyId}/limit=${
      limit && limit
    }`,
    config
  );
  return response;
}

export function getContractWithContractId(contractId) {
  let authToken = localStorage.getItem("usertoken");

  console.log("contractId::::", contractId);
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/contract/get/${contractId}`,
    config
  );
  return response;
}

export function deleteContract(cntractIdToDelete) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.delete(
    `${API_END_POINT}/company/contract/delete/${cntractIdToDelete}`,
    config
  );
  return response;
}

export function updateFabricContract(contractIdToUpdate, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(updatedData);
  let response = axios.put(
    `${API_END_POINT}/company/contract/edit/fabric/${contractIdToUpdate}`,
    body,
    config
  );
  return response;
}

export function updateConversionContract(contractIdToUpdate, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(updatedData);
  let response = axios.put(
    `${API_END_POINT}/company/contract/edit/conversion/${contractIdToUpdate}`,
    body,
    config
  );
  return response;
}
